import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { toRoman } from 'helpers'

import styles from './Suitability.scss'

const LEVEL_ARRAY = new Array(5).fill(null)

const Suitability = ({ title, level, strongholdLevel }) => {
    return (
        <div className={styles.base}>
            <div className={styles.titleContainer}>
                {title}
                {strongholdLevel && (
                    <span className={styles.strongholdLevel}>{toRoman(strongholdLevel)}</span>
                )}
            </div>
            <div className={styles.levels}>
                {LEVEL_ARRAY.map((_, index) => (
                    <div className={cx(styles.level, index < level && styles.level__active)} key={index} />
                ))}
            </div>
        </div>
    )
}

Suitability.propTypes = {
    title: PropTypes.object.isRequired,
    level: PropTypes.number.isRequired,
    strongholdLevel: PropTypes.number,
}

export default Suitability



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Card/components/Suitability/Suitability.jsx